import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import { RecepientDetail } from '@/types/CartTypes';

@Module({
  namespaced: true
})
class recepientDetailModule extends VuexModule {
  private recepient: RecepientDetail = {} as RecepientDetail ;

  get getRecepient() {
    return this.recepient;
  }

  @Mutation
  setRecepient(value: RecepientDetail) {
    this.recepient = value;
  }

  @Action({ commit: 'setRecepient', rawError: true })
  async addRecepient(payload:  RecepientDetail): Promise<RecepientDetail> {
    return payload;
  }
}

export default recepientDetailModule;
